// custom-carousel.js
(() => {
  const SELECTOR = 'swiper-component.swiper, .swiper';

  function enhanceSwiperInstance(swiper) {
    if (!swiper || swiper.__customEnhanced) return;
    swiper.__customEnhanced = true;

    // Force desktop drag to behave like touch (moves while pointer moves)
    swiper.params.simulateTouch = true;
    swiper.params.followFinger = true;
    swiper.params.allowTouchMove = true;

    // Makes mouse behave more like touch
    swiper.params.touchStartPreventDefault = false;
    swiper.params.touchMoveStopPropagation = true;

    // Small friction improvements
    swiper.params.threshold = 0;        // start moving immediately
    swiper.params.shortSwipes = true;
    swiper.params.longSwipes = true;

    // Ensure Swiper recalculates with new params
    swiper.update();

    // Kill "no-drop" / image dragging behavior that causes 🚫 cursor
    const el = swiper.el || swiper.wrapperEl || swiper.hostEl;
    if (el) {
      el.addEventListener('dragstart', (e) => e.preventDefault(), true);
      el.addEventListener('selectstart', (e) => e.preventDefault(), true);
    }

    // Debug (remove later)
    console.log('[custom-carousel] enhanced swiper:', swiper);
  }

  function findAndEnhance() {
    document.querySelectorAll(SELECTOR).forEach((node) => {
      // If this is a swiper-component web component, swiper may live on node.swiper
      const maybeSwiper =
        node.swiper ||
        node?.__swiper ||
        node?.swiperInstance ||
        node?.querySelector?.('.swiper')?.swiper;

      if (maybeSwiper) enhanceSwiperInstance(maybeSwiper);
    });
  }

  // Wait for Swiper to appear (covers delayed init)
  function startObserver() {
    findAndEnhance();

    const obs = new MutationObserver(() => findAndEnhance());
    obs.observe(document.documentElement, { childList: true, subtree: true });

    // Shopify theme editor: sections can re-render
    document.addEventListener('shopify:section:load', findAndEnhance);
    document.addEventListener('shopify:section:reorder', findAndEnhance);
    document.addEventListener('shopify:section:select', findAndEnhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();
